import styled from '@emotion/styled';
import { breakpoints, radius, spacing } from '@naf/theme';
import { IconButton } from '@naf-simba/elements-buttons';
import { CARD_WIDTH, CARD_GAP } from './ShortsCarousel.utils';

export const OuterWrapper = styled.div`
  position: relative;
  overflow: visible;
  margin-left: -${spacing.space48};
  margin-right: -${spacing.space48};
  width: calc(100% + ${spacing.space48} * 2);
`;

export const CarouselContainer = styled.section<{ $backgroundColor: string; $hasTitle: boolean }>`
  position: relative;
  padding-top: ${({ $hasTitle }) => ($hasTitle ? spacing.space16 : '46px')};
  padding-bottom: 46px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  z-index: 1;

  @media (min-width: ${breakpoints.l}) {
    padding-left: ${spacing.space48};
    padding-right: ${spacing.space48};
  }
`;

export const InternalContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing.space24};
`;

export const CarouselTitle = styled.h2`
  font-size: 1.75rem;
  line-height: 36px;
  font-weight: 900;
  margin: 0;

  @media (max-width: ${breakpoints.l}) {
    margin-left: ${spacing.space48};
  }
`;

export const CarouselWrapper = styled.div<{ $isSingleVideo?: boolean }>`
  display: flex;
  align-items: center;
  overflow: visible;
  justify-content: ${({ $isSingleVideo }) => ($isSingleVideo ? 'center' : 'flex-start')};
`;

export const ScrollContainer = styled.div<{ $isSingleVideo?: boolean }>`
  overflow-x: ${({ $isSingleVideo }) => ($isSingleVideo ? 'hidden' : 'auto')};
  display: flex;
  gap: ${CARD_GAP}px;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  /* Hide scrollbar on all devices */
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${breakpoints.l}) {
    padding-left: ${spacing.space48};
    padding-right: ${spacing.space48};
    scroll-padding-left: ${spacing.space48};
    scroll-padding-right: ${spacing.space48};
  }
`;

export const VideoCard = styled.div<{ $isActive?: boolean }>`
  flex: 0 0 ${CARD_WIDTH}px;
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;
  gap: ${spacing.space8};
  transition: transform 0.2s ease;

  @media (max-width: ${breakpoints.l}) {
    flex: 0 0 calc(100vw - 80px);
    max-width: ${CARD_WIDTH}px;
  }
`;

export const VideoIframe = styled.iframe`
  width: ${CARD_WIDTH}px;
  aspect-ratio: 9 / 16;
  border: 0;
  border-radius: ${radius.m};

  @media (max-width: ${breakpoints.m}) {
    width: 100%;
  }
`;

export const StyledArrowLeft = styled(IconButton)`
  @media (max-width: ${breakpoints.m}) {
    display: none;
  }

  position: absolute;
  left: -${spacing.space20};
  z-index: 10;
`;

export const StyledArrowRight = styled(IconButton)`
  @media (max-width: ${breakpoints.m}) {
    display: none;
  }

  position: absolute;
  right: -${spacing.space20};
  z-index: 10;
`;
